const TRAIL_PAGE_CLASS = 'dk-itinerario-escursione'

if (document.documentElement.classList.contains(TRAIL_PAGE_CLASS)) {
  const article = document.querySelector('#content.article')
  const coverImage = article?.querySelector(':scope > .fotoDidascaliaSx')

  coverImage?.classList.add('trail-print-cover')
  const section = document.querySelector('.section')
  const originalLogo = document.querySelector('.lo .logo-cnt img')

  if (section) {
    const printHeader = document.createElement('header')
    printHeader.className = 'trail-print-header'

    const printLogo = originalLogo?.cloneNode(true) || document.createElement('img')

    if (!originalLogo) {
      printLogo.src = '/images/css/logo.svg'
      printLogo.alt = 'Asiago.it'
    }

    printLogo.removeAttribute('width')
    printLogo.removeAttribute('height')
    printLogo.className = 'trail-print-header__logo'

    const printMeta = document.createElement('div')
    printMeta.className = 'trail-print-header__meta'

    const printSectionTitle = document.createElement('strong')
    printSectionTitle.textContent =
      document.querySelector('.lo .titoli-cnt h1')?.textContent.trim() ||
      'Itinerari escursioni e passeggiate'

    const printUrl = document.createElement('span')
    printUrl.textContent = window.location.href.split('#')[0]

    printMeta.append(printSectionTitle, printUrl)
    printHeader.append(printLogo, printMeta)

    section.insertAdjacentElement('beforebegin', printHeader)
  }

  function syncPrintBannerVisibility() {
    for (const box of document.querySelectorAll('.boxPub')) {
      const hasOwnBanner = Array.from(box.querySelectorAll('.bannerright')).some(
        banner =>
          banner.querySelector('img, iframe, a, object, embed') ||
          banner.textContent.trim().length > 0
      )

      box.classList.toggle('boxPub--print-visible', hasOwnBanner)
    }
  }

  let isPrintMode = false
  const readmorePrintState = []
  let detachedTrailStatus = null
  let printSidebarState = null
  let printAdvertiserState = null
  const printSectionWrappers = []

  function expandReadmoresForPrint() {
    if (readmorePrintState.length > 0) {
      return
    }

    const toggles = Array.from(document.querySelectorAll('[data-readmore-toggle]'))

    for (const content of document.querySelectorAll('.trailStatus [data-readmore]')) {
      const toggle = toggles.find(
        element => element.getAttribute('data-readmore-toggle') === content.id
      )

      readmorePrintState.push({
        content,
        contentStyle: content.getAttribute('style'),
        ariaExpanded: content.getAttribute('aria-expanded'),
        toggle,
        toggleStyle: toggle?.getAttribute('style') ?? null,
      })

      content.style.setProperty('height', 'auto', 'important')
      content.style.setProperty('max-height', 'none', 'important')
      content.style.setProperty('overflow', 'visible', 'important')
      content.setAttribute('aria-expanded', 'true')

      toggle?.style.setProperty('display', 'none', 'important')
    }
  }

  function normalizeTechnicalBoxForPrint() {
    const technicalBox = article?.querySelector('.escursioni')
    const trailStatus = article?.querySelector('.trailStatus')

    if (
      !technicalBox ||
      !trailStatus ||
      technicalBox.contains(trailStatus) ||
      detachedTrailStatus
    ) {
      return
    }

    const placeholder = document.createComment('trail-status-print-position')

    trailStatus.parentNode?.insertBefore(placeholder, trailStatus)
    technicalBox.append(trailStatus)

    detachedTrailStatus = {
      trailStatus,
      placeholder,
    }
  }

  function restoreTechnicalBoxAfterPrint() {
    if (!detachedTrailStatus) {
      return
    }

    detachedTrailStatus.placeholder.replaceWith(detachedTrailStatus.trailStatus)
    detachedTrailStatus = null
  }

  function buildPrintSidebar() {
    if (printSidebarState || !article) {
      return
    }

    const technicalBox = article.querySelector('.escursioni')

    if (!technicalBox) {
      return
    }

    const placeholder = document.createComment('trail-technical-print-position')

    technicalBox.before(placeholder)

    const sidebar = document.createElement('aside')
    sidebar.className = 'trail-print-sidebar'

    placeholder.after(sidebar)
    sidebar.append(technicalBox)

    printSidebarState = {
      sidebar,
      technicalBox,
      placeholder,
    }
  }

  function restorePrintSidebar() {
    if (!printSidebarState) {
      return
    }

    const { sidebar, technicalBox, placeholder } = printSidebarState

    placeholder.replaceWith(technicalBox)
    sidebar.remove()

    printSidebarState = null
  }

  const printSectionBoundarySelector = [
    '.minisite-article-links',
    '.iframe-container-trailmap',
    '.iframe-container-trailquote',
    '.gallery-cnt',
    '.share',
    '.trail-share-actions',
    '.syfb',
    '.boxPub',
  ].join(',')

  function groupTrailSectionsForPrint() {
    if (!article || printSectionWrappers.length > 0) {
      return
    }

    const children = Array.from(article.children)
    let currentSection = null

    for (const child of children) {
      if (child.matches('.trail-print-sidebar')) {
        continue
      }

      if (child.matches('h2')) {
        currentSection = document.createElement('section')
        currentSection.className = 'trail-print-section'

        child.before(currentSection)
        currentSection.append(child)
        printSectionWrappers.push(currentSection)

        continue
      }

      if (!currentSection) {
        continue
      }

      if (child.matches(printSectionBoundarySelector)) {
        currentSection = null
        continue
      }

      currentSection.append(child)
    }
  }

  function unwrapTrailSectionsAfterPrint() {
    for (const wrapper of printSectionWrappers) {
      while (wrapper.firstChild) {
        wrapper.before(wrapper.firstChild)
      }

      wrapper.remove()
    }

    printSectionWrappers.length = 0
  }

  function moveAdvertiserBoxForPrint() {
    if (printAdvertiserState || !article) {
      return
    }

    const advertiserBox = article.querySelector('.minisite-article-links')

    if (!advertiserBox) {
      return
    }

    const placeholder = document.createComment(
      'trail-advertiser-print-position'
    )

    advertiserBox.before(placeholder)

    const firstGraph = article.querySelector(
      ':scope > .iframe-container-trailmap, :scope > .iframe-container-trailquote'
    )

    const gallery = article.querySelector(':scope > .gallery-cnt')

    if (firstGraph) {
      firstGraph.before(advertiserBox)
    } else if (gallery) {
      gallery.before(advertiserBox)
    } else {
      article.append(advertiserBox)
    }

    printAdvertiserState = {
      advertiserBox,
      placeholder,
    }
  }

  function restoreAdvertiserBoxAfterPrint() {
    if (!printAdvertiserState) {
      return
    }

    printAdvertiserState.placeholder.replaceWith(
      printAdvertiserState.advertiserBox
    )

    printAdvertiserState = null
  }

  function prepareTrailContentForPrint() {
    normalizeTechnicalBoxForPrint()
    expandReadmoresForPrint()
    buildPrintSidebar()
    groupTrailSectionsForPrint()
    moveAdvertiserBoxForPrint()
  }

  function restoreTrailContentAfterPrint() {
    restoreAdvertiserBoxAfterPrint()
    unwrapTrailSectionsAfterPrint()
    restorePrintSidebar()
    restoreReadmoresAfterPrint()
    restoreTechnicalBoxAfterPrint()
  }

  function restoreReadmoresAfterPrint() {
    for (const state of readmorePrintState) {
      if (state.contentStyle === null) {
        state.content.removeAttribute('style')
      } else {
        state.content.setAttribute('style', state.contentStyle)
      }

      if (state.ariaExpanded === null) {
        state.content.removeAttribute('aria-expanded')
      } else {
        state.content.setAttribute('aria-expanded', state.ariaExpanded)
      }

      if (state.toggle) {
        if (state.toggleStyle === null) {
          state.toggle.removeAttribute('style')
        } else {
          state.toggle.setAttribute('style', state.toggleStyle)
        }
      }
    }

    readmorePrintState.length = 0
  }

  function syncTrailIframePrintStyles() {
    const iframes = document.querySelectorAll(
      '.iframe-container-trailmap iframe, .iframe-container-trailquote iframe'
    )

    for (const iframe of iframes) {
      let iframeDocument

      try {
        iframeDocument = iframe.contentDocument
      } catch {
        continue
      }

      if (!iframeDocument?.head) {
        continue
      }

      const currentStyle = iframeDocument.getElementById('trail-iframe-print-style')

      if (!isPrintMode) {
        currentStyle?.remove()
        continue
      }

      if (currentStyle) {
        continue
      }

      const style = iframeDocument.createElement('style')
      style.id = 'trail-iframe-print-style'
      style.textContent = `
        html,
        body {
          width: 100% !important;
          min-width: 0 !important;
          max-width: none !important;
          height: 100% !important;
          margin: 0 !important;
          padding: 0 !important;
          overflow: hidden !important;
        }

        body > *,
        #gmap_div,
        canvas,
        svg,
        img {
          max-width: 100% !important;
        }

        #gmap_div {
          width: 100% !important;
          height: 100% !important;
        }

        canvas,
        svg,
        img {
          height: auto !important;
        }
      `

      iframeDocument.head.append(style)
    }
  }

  for (const iframe of document.querySelectorAll(
    '.iframe-container-trailmap iframe, .iframe-container-trailquote iframe'
  )) {
    iframe.addEventListener('load', syncTrailIframePrintStyles)
  }

  syncPrintBannerVisibility()

  window.addEventListener('beforeprint', () => {
    isPrintMode = true
    prepareTrailContentForPrint()
    syncPrintBannerVisibility()
    syncTrailIframePrintStyles()
  })

  window.addEventListener('afterprint', () => {
    isPrintMode = false
    restoreTrailContentAfterPrint()
    syncTrailIframePrintStyles()
  })

  const googlePrintArtifacts = new Set()

  function markGooglePrintArtifacts() {
    const selectors = [
      'ins.adsbygoogle',
      '.adsbygoogle-noablate',
      '.google-auto-placed',
      '[data-anchor-status]',
      '[data-anchor-shown]',
      '.grippy-host',
      '[class*="grippy-host"]',
      '[data-google-query-id]',
      '[id^="aswift_"]',
      '[id^="google_ads_iframe_"]',
      'iframe[title="Advertisement"]',
      'iframe[src*="googleads"]',
      'iframe[src*="doubleclick"]',
    ].join(',')

    for (const element of document.querySelectorAll(selectors)) {
      let target = element

      /*
       * Gli annunci side rail e anchor possono avere un contenitore
       * esterno fixed/sticky, separato dall'iframe.
       */
      for (
        let current = element;
        current && current !== document.body;
        current = current.parentElement
      ) {
        const position = window.getComputedStyle(current).position
        const className =
          typeof current.className === 'string' ? current.className : ''
        const marker = `${current.id} ${className}`

        if (
          position === 'fixed' ||
          position === 'sticky' ||
          /anchor|side.?rail|grippy/i.test(marker)
        ) {
          target = current
        }

        if (position === 'fixed' || position === 'sticky') {
          break
        }
      }

      target.classList.add('trail-print-google-artifact')
      googlePrintArtifacts.add(target)
    }
  }

  function clearGooglePrintArtifacts() {
    for (const element of googlePrintArtifacts) {
      element.classList.remove('trail-print-google-artifact')
    }

    googlePrintArtifacts.clear()
  }

  window.addEventListener('beforeprint', markGooglePrintArtifacts)
  window.addEventListener('afterprint', clearGooglePrintArtifacts)

  const button = document.createElement('button')

  button.type = 'button'
  button.className = 'trail-print-button'
  button.innerHTML = `
    <span class="material-icons trail-print-button__icon" aria-hidden="true">print</span>
    <span>Stampa itinerario</span>
  `

  button.addEventListener('click', () => {
    prepareTrailContentForPrint()
    markGooglePrintArtifacts()

    requestAnimationFrame(() => {
      window.print()
    })
  })

  const shareContainer = document.querySelector('.share')
  const facebookShare = shareContainer?.querySelector('.share--facebook')

  if (shareContainer && facebookShare) {
    const actionsContainer = document.createElement('div')
    actionsContainer.className = 'trail-share-actions'

    facebookShare.insertAdjacentElement('beforebegin', actionsContainer)
    actionsContainer.append(facebookShare, button)
  } else {
    const gallery = document.querySelector('.gallery-cnt')

    if (gallery) {
      gallery.insertAdjacentElement('afterend', button)
    }
  }
}
